import { yyrequest } from '@/utils/yyRequest.js';
import jsonpRequest from '@/utils/jsonpRequest.js';
import { axiosExt } from '@/utils/axios.js';
import { post } from '@/utils/baseRequest';

// 埋点-auth治理
export function logEvent(data) {
  return post('/h5/v1/common/log/unicorn/event', data, { 'Content-Type': 'application/json' })
    .then((res) => {
      // console.log('oooooooo', res);
    })
    .catch((err) => {
      console.log('err', err);
    });
}

// 获取司机端云控
export function getCloudConfigByModule({ group, moduleName, configName, tenantId }) {
  return new Promise((resolve, reject) => {
    axiosExt({
      url: '/h5/v1/common/config/module/update',
      data: {
        group,
        moduleName,
        tenantId
      }
    })
      .then((res) => {
        resolve(res);
      })
      .catch((rej) => {
        reject(rej);
      });
  });
}

// 推广系统-培训资料
export function reqTrainingList(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/training/list`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 推广系统-上报线索-列表
export function reqReportPageList(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/report/page`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 推广系统-上报线索-上报数据类型
export function reqReportType(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/report/type`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 薪资管理-查询支持配置项目
export function reqSalaryTemplateDefaultConfig(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/salary/template/defaultConfig`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 薪资管理-查询对应团队规则配置信息
export function reqSalaryTemplateGroupDetail(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/salary/template/groupDetail`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 薪资管理-规则修改/新增
export function reqSalaryTemplateOperation(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/salary/template/operation`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 薪资管理-查询薪资列表
export function reqSalaryList(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/salary/list`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 薪资管理-调整薪资
export function reqSalaryAdjust(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/salary/adjust`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 薪资管理-确认薪资
export function reqSalaryConfirm(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/salary/confirm`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}

// 薪资管理-薪资详情
export function reqSalaryMemberDetail(param, time) {
  return new Promise((resolve) => {
    const sign = ['_yy_eid', 'diu'];
    yyrequest(`/api/v1/unicorn/temporary/salary/memberDetail`, param, time, sign, (res) => {
      resolve(res);
    });
  });
}